import React from 'react';
import styled from 'styled-components';

const DashboardPageContainer = styled.div`
    padding-top: 16px;
    
    .product_share_pie_card {
        .ant-card-body {
            margin: 20px;
        }        
    }
    .issue-days {
        width: 60px;
        margin-left: 5px;
        margin-right: 5px;
    }
`;

export default DashboardPageContainer;